import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  padding: 30px;
  overflow: hidden;
  z-index: 99999999999999999999999999999;

  @media (max-width: 820px) {
    padding: 0;
    right: 0;
    left: 0;

    > div {
      width: 100% !important;
    }
  }
`;
